import { RequestType } from "../API";

export const typeDisplay = (type: RequestType | null | undefined): string => {
  if (!type) return 'Request';
  const words = type.split('_').map(word => {
    return `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`;
  })
  return words.join(' ');
}